<template>
  <a
    class="w-[288px] bg-white rounded-[15px] overflow-hidden cursor-pointer transition-transform hover:scale-[1.02]"
    @click="handleClick"
  >
    <div class="relative w-[288px] h-[285px] rounded-t-[15px] overflow-hidden">
      <!-- 图片 -->
      <img :src="coverUrl" :alt="title" class="w-full h-full object-cover" />

      <!-- 已读标签 - 贴紧右上角 -->
      <ViewedBadge
        v-if="viewed"
        variant="corner"
        class="absolute top-[-1px] right-0"
      />
    </div>

    <!-- 标题和更新时间 -->
    <div
      class="box-border w-full !pt-[25px] !px-[20px] !pb-[10px] flex flex-col border-solid border-l border-r border-b border-[#E0E0E0] rounded-b-[15px]"
    >
      <!-- 标题 -->
      <div
        class="line-clamp-2 text-[26px] font-normal leading-[135%] text-[#202020] !mb-[10px]"
      >
        {{ title }}
      </div>

      <!-- 更新时间 -->
      <div
        v-if="updateTime"
        class="font-normal leading-[140%] tracking-[-0.02em] text-black/50"
        :class="isEnglish ? 'text-[22px]' : 'text-[22px]'"
      >
        {{ formatUpdateTime(updateTime) }}
      </div>
    </div>
  </a>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import ViewedBadge from './ViewedBadge.vue';
import { lang } from '../utils/lang';
import $t from '../utils/i18n';
import { ELang } from '@ark/utils';
interface Props {
  materialId: string;
  title: string;
  coverUrl: string;
  jumpUrl: string;
  viewed: boolean;
  updateTime?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  materialId: {
    key: "materialId",
    required: true,
    type: String
  },
  title: {
    key: "title",
    required: true,
    type: String
  },
  coverUrl: {
    key: "coverUrl",
    required: true,
    type: String
  },
  jumpUrl: {
    key: "jumpUrl",
    required: true,
    type: String
  },
  viewed: {
    key: "viewed",
    required: true,
    type: Boolean
  },
  updateTime: {
    key: "updateTime",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 语言判断
  const isEnglish = computed(() => lang === ELang.KV.EN);

  // 多语言文案（使用 computed 确保响应式）
  const updateTemplate = computed(() => $t('DateFormat.updateTemplate'));
  const emit = __ctx.emit;
  function handleClick() {
    emit('click', props.materialId, props.jumpUrl);
  }

  // 格式化更新时间（支持多语言）
  function formatUpdateTime(dateStr: string): string {
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return updateTemplate.value.replace('{month}', month).replace('{day}', day);
  }
  return {
    isEnglish,
    handleClick,
    formatUpdateTime
  };
};
__sfc_main.components = Object.assign({
  ViewedBadge
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
